import { GetKitDto } from "@/lib/gen-api";
import { getDefaultKitColorClassName, getDefaultKitIcon } from "./defaults";
import { DisplayName } from "./DisplayName";

export function KitDisplayName({
  kit,
  className,
}: {
  kit: Pick<GetKitDto, "name" | "type">;
  className?: string;
}) {
  const icon = getDefaultKitIcon(kit);
  const color = getDefaultKitColorClassName(kit);

  return (
    <DisplayName
      name={kit.name}
      icon={icon}
      colorClassName={color}
      className={className}
    />
  );
}
